import { jsx as l } from "react/jsx-runtime";
const h = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        fillRule: "evenodd",
        d: "M10.772 2.076A10 10 0 0 0 2.835 8h5.59a19.4 19.4 0 0 1 2.347-5.924M2.202 10a10 10 0 0 0 0 4h5.903a19 19 0 0 1 0-4zm.633 6a10 10 0 0 0 7.937 5.924A19.4 19.4 0 0 1 8.425 16zm11.35 5.759A10 10 0 0 0 21.164 16h-5.453a25.4 25.4 0 0 1-1.528 5.759M21.797 14a10 10 0 0 0 0-4h-5.87a28 28 0 0 1 0 4zm-.633-6h-5.453a25.4 25.4 0 0 0-1.528-5.758A10 10 0 0 1 21.165 8M12.42 3.218c.58 1.5 1.007 3.11 1.27 4.782h-3.213a17.4 17.4 0 0 1 1.943-4.782M10.118 10h3.805a26 26 0 0 1 0 4h-3.805a17 17 0 0 1 0-4m.358 6h3.213a23.4 23.4 0 0 1-1.27 4.782A17.4 17.4 0 0 1 10.476 16",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  h as default
};
